// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const getTableSettings = (payload = null) => http.post('apiExportData/getTableSettings', payload).then(getData);

export const get = (payload = null, silentVal = false) => http.post('apiExportData/getRows', payload, {silent:silentVal}).then(getData);

export const getRow = (rowID) => http.get(`apiExportData/getRow&RowID=${rowID}`).then(getData);

export const create = (row) => http.post('apiExportData/addRow', row).then(getData);

export const remove = (row) => http.post('apiExportData/deleteRow',row).then(getData);

export const update = (row) => http.post('apiExportData/editRow',row).then(getData);